export const SET_USER = 'SET_USER';
export const UNSET_USER = 'UNSET_USER';
export const SET_ACTIVITY_LOGS = 'SET_ACTIVITY_LOGS';
export const SET_CAUSE_DETAILS = 'SET_CAUSE_DETAILS';
export const SET_ROUNDUPS_VISIBILITY = 'SET_ROUNDUPS_VISIBILITY';
export const SET_CONTRIBUTE_NOW_VISIBILITY = 'SET_CONTRIBUTE_NOW_VISIBILITY';
export const SET_USER_IDENTITY = 'SET_USER_IDENTITY';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';